import { render, staticRenderFns } from "./LayoutBack.vue?vue&type=template&id=4ada9400&scoped=true&"
import script from "./LayoutBack.vue?vue&type=script&lang=js&"
export * from "./LayoutBack.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBack.vue?vue&type=style&index=0&id=4ada9400&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ada9400",
  null
  
)

export default component.exports